import { LoadingSpinner } from '../common';
import { PipelineWithRunsDto } from '../../types/pipelineFlow';
import { useDebouncedLoading } from '../../hooks/useDebouncedLoading';

interface PipelineActionsProps {
  pipeline: PipelineWithRunsDto;
  limit: number;
  isRefreshing: boolean;
  showFilters: boolean;
  hasActiveFilters: boolean;
  onRefresh: () => void;
  onToggleFilters: () => void;
}

export function PipelineActions({
  pipeline,
  limit,
  isRefreshing,
  showFilters,
  hasActiveFilters,
  onRefresh,
  onToggleFilters,
}: PipelineActionsProps) {
  const activeFilterCount = hasActiveFilters ? 1 : 0;
  const { isVisible: showRefreshSpinner } = useDebouncedLoading(isRefreshing, {
    showDelay: 100,
    minDisplayTime: 300,
    cooldownPeriod: 200
  });

  return (
    <div className="mt-4 flex md:ml-4 md:mt-0">
      <a
        href={pipeline.pipelineUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-secondary"
      >
        <svg className="mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
        </svg>
        View Pipeline
      </a>
      <button
        onClick={onRefresh}
        disabled={isRefreshing}
        className="btn-primary"
      >
        {showRefreshSpinner ? (
          <LoadingSpinner size="sm" className="mr-2" variant="dots" />
        ) : (
          <svg className="mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
          </svg>
        )}
        Refresh Runs ({limit})
      </button>
      
      <button
        onClick={onToggleFilters}
        className={`px-3 py-1.5 rounded-lg border transition-colors text-sm ${
          showFilters || hasActiveFilters
            ? 'bg-blue-50 border-blue-300 text-blue-700'
            : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'
        }`}
      >
        {showFilters ? 'Hide Filters' : 'Show Filters'}
        {activeFilterCount > 0 && (
          <span className="ml-1 bg-blue-600 text-white text-xs px-1.5 py-0.5 rounded-full">
            {activeFilterCount}
          </span>
        )}
      </button>
    </div>
  );
}